import { render } from "./SubHeader.vue?vue&type=template&id=3d5405f0&scoped=true"
import script from "./SubHeader.vue?vue&type=script&lang=ts"
export * from "./SubHeader.vue?vue&type=script&lang=ts"

import "./SubHeader.vue?vue&type=style&index=0&id=3d5405f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d5405f0"

export default script